import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, TextField, Grid, Paper, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { useForm, Controller } from "react-hook-form";
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@material-ui/icons/Search';
import { NotificationActions, AdjustmentFeeListActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    headerStyle1: {
        backgroundColor: '#e6ffe8bf',
        color: '#0f0f0f'
    },
    headerStyle2: {
        backgroundColor: '#ffeeddbf',
        color: '#0f0f0f'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const feeSelector = (state) => state.AdjustmentFeeList;
const IdentitySelector = (state) => state.Identity;

const FeeList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const adjustmentFeeListActions = bindActionCreators(AdjustmentFeeListActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { adjustmentlist, nowWainting } = useSelector(feeSelector);

    const { token } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, handleSubmit } = useForm();

    const { classes } = props;

    const listDefinition = {
        columns: [
            {
                // 代理加盟店名
                title: <FeeList id="FeeList.AcquirerName" />,
                field: 'acquirer_name',
                filtering: true
            },
            {
                // 加盟店名
                title: <FormattedMessage id="FeeList.MerchantName" />,
                field: 'merchant_name',
                filtering: true
            },
            {
                // クレジットカード決済代行業者名称
                title: <FormattedMessage id="FeeList.CreditCardPaymentAgencyName" />,
                field: 'credit_card_payment_agency_name',
                filtering: false
            },
            {
                // 加盟店タイプ・合計カラム
                field: 'row_type_name',
                filtering: false,
            },
            {
                // システム手数料率-カード
                title: <FormattedMessage id="FeeList.Card" />,
                field: 'system_fee_okica_card_payment',
                filtering: false,
            },
            {
                // システム手数料率-カード-ブランド
                title: <FormattedMessage id="FeeList.Brand" />,
                field: 'brand_fee_okica_card_payment',
                filtering: false,
            },
            {
                // システム手数料率-QR
                title: <FormattedMessage id="FeeList.QR" />,
                field: 'system_fee_qr_payment',
                filtering: false,
            },
            {
                // システム手数料率-QR-ブランド
                title: <FormattedMessage id="FeeList.Brand" />,
                field: 'brand_fee_qr_payment',
                filtering: false,
            },
            {
                // チャージ手数料率-チャージ
                title: <FormattedMessage id="FeeList.Charge" />,
                field: 'merchant_fee_okica_card_charge',
                filtering: false,
            },
            {
                // チャージ手数料率-移動
                title: <FormattedMessage id="FeeList.Transfer" />,
                field: 'merchant_fee_okica_card_value_exchange',
                filtering: false,
            },
            {
                // 手数料率-システム
                title: <FormattedMessage id="FeeList.System" />,
                field: 'system_fee_credit_card_payment',
                filtering: false,
            },
            {
                // 手数料率-ブランド
                title: <FormattedMessage id="FeeList.Brand" />,
                field: 'brand_fee_credit_card_payment',
                filtering: false,
            },
            {
                // 手数料率-システム
                title: <FormattedMessage id="FeeList.System" />,
                field: 'system_fee_bank_payment',
                filtering: false,
            },
            {
                // 手数料率-ブランド
                title: <FormattedMessage id="FeeList.Brand" />,
                field: 'brand_fee_bank_payment',
                filtering: false,
            },
        ]
    };

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        if (props.refresh == null || props.refresh == true) {
            // 一覧を初期化
            adjustmentFeeListActions.initListAdjustmentFees();
        }

    }, []);

    /**
     * 
     * 検索ボタン押下時の処理
     * 
     */
    const onSearchClick = () => {
        // 一覧を取得
        adjustmentFeeListActions.listAdjustmentFees(token, date)
            .then(data => {
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;

        if (name.startsWith('date')) {
            var dt = new Date(value);
            var targetDt = dt.getFullYear() + '/' + ("0" + (dt.getMonth() + 1)).slice(-2) + '/' + ("0" + dt.getDate()).slice(-2);
            setDate(targetDt);
        }

        return value;
    }

    /**
     *
     * 3段区切りの文字列の変換(数値)
     *
     */
    const ToStringChangeNumber = (feePayment) => {

        // カンマで分割し配列に格納
        var resArray = feePayment.split(',');
        var ret = "";   // 戻り値
        for (var i = 0; i < resArray.length; i++) {

            if (i == 0) {
                ret += Number(resArray[i]).toFixed(2);
            } else {
                ret += "<br/>" + Number(resArray[i]).toFixed(2);
            }
        }
        return ret;
    }

    /**
    *
    * 3段区切りの文字列の変換(名称)
    *
    */
    const ToStringChangeName = (paymentName) => {

        if (paymentName == null || paymentName == undefined) {
            return;
        }

        // カンマで分割し配列に格納
        var resArray = paymentName.split(',');

        var ret = "";   // 戻り値
        for (var i = 0; i < resArray.length; i++) {

            if (i == 0) {
                ret += resArray[i];
            } else {
                ret += "<br/>" + resArray[i];
            }
        }
        return ret;
    }

    // 当日を初期表示
    var dt = new Date();
    var targetDt = dt.getFullYear() + '/' + ("0" + (dt.getMonth() + 1)).slice(-2) + '/' + ("0" + dt.getDate()).slice(-2);
    var defautValue = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    const [date, setDate] = useState(targetDt);

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} onSubmit={handleSubmit(onSearchClick)} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="FeeList.List" /></Typography>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={handleSubmit(onSearchClick)}><FormattedMessage id="Button.Search" /></Button>
                                </div>
                            </div>

                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Controller
                                    name="date"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={defautValue}
                                    as={<TextField fullWidth variant="outlined"
                                        id="adjustment-date"
                                        label={<FormattedMessage id={"FeeList.Date"} />}
                                        type="date"
                                        className={classes.textField}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />} />
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <MaterialTable
                title={<Typography component="h1" variant="inherit"></Typography>}
                columns={listDefinition.columns}
                data={adjustmentlist}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                    pageSize: 9,
                    pageSizeOptions: [9, 15, 30]
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Header: props => {
                        // 2段組みヘッダ
                        return (
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2}><FormattedMessage id="FeeList.AcquirerName" /></TableCell>
                                    <TableCell rowSpan={2}><FormattedMessage id="FeeList.MerchantName" /></TableCell>
                                    <TableCell rowSpan={2}><FormattedMessage id="FeeList.CreditCardPaymentAgencyName" /></TableCell>
                                    <TableCell rowSpan={2}>　　</TableCell>
                                    <TableCell colSpan={4} align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.SystemFee" /></TableCell>
                                    <TableCell colSpan={2} align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.ChargeFee" /></TableCell>
                                    <TableCell colSpan={2} align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.CreditFee" /></TableCell>
                                    <TableCell colSpan={2} align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.BankFee" /></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.Card" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.Brand" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.Qr" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.Brand" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.Charge" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.Exchange" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.System" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle1}><FormattedMessage id="FeeList.Brand" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.System" /></TableCell>
                                    <TableCell align="center" className={classes.headerStyle2}><FormattedMessage id="FeeList.Brand" /></TableCell>
                                </TableRow>
                            </TableHead>
                        );
                    },
                    Row: ({ data }) => {
                        var merchantName = data.merchant_name;
                        var classAlign = 'left';
                        if (data.merchant_name == null || data.merchant_name == undefined) {
                            merchantName = '―';
                            classAlign = 'center';
                        }

                        var creditCardPaymentAgencyName = ToStringChangeName(data.credit_card_payment_agency_name);

                        // 小数点形式
                        var systemFeeOkicaCardPayment = (data.system_fee_okica_card_payment != null)? Number(data.system_fee_okica_card_payment).toFixed(2):'―';
                        var brandFeeOkicaCardPayment = (data.system_fee_okica_card_payment != null) ? Number(data.brand_fee_okica_card_payment).toFixed(2) : '―';
                        var systemFeeQrPayment = (data.system_fee_okica_card_payment != null) ? Number(data.system_fee_qr_payment).toFixed(2) : '―';
                        var brandFeeQrPayment = (data.system_fee_okica_card_payment != null) ? Number(data.brand_fee_qr_payment).toFixed(2) : '―';
                        var merchantFeeOkicaCardCharge = (data.system_fee_okica_card_payment != null) ? Number(data.merchant_fee_okica_card_charge).toFixed(2) : '―';
                        var merchantFeeOkicaCardValueExchange = (data.system_fee_okica_card_payment != null) ? Number(data.merchant_fee_okica_card_value_exchange).toFixed(2) : '―';
                        var systemFeeCreditCardPayment = (data.system_fee_okica_card_payment != null) ? ToStringChangeNumber(data.system_fee_credit_card_payment) : '―';
                        var brandFeeCreditCardPayment = (data.system_fee_okica_card_payment != null) ? ToStringChangeNumber(data.brand_fee_credit_card_payment) : '―';
                        var systemFeeBankPayment = (data.system_fee_okica_card_payment != null) ? Number(data.system_fee_bank_payment).toFixed(2) : '―';
                        var brandFeeBankPayment = (data.system_fee_okica_card_payment != null) ? Number(data.brand_fee_bank_payment).toFixed(2) : '―';
                        if (data.row_type_name == '沖縄IC') {
                            return (
                                // 代表加盟店名・加盟店名のセルを3行結合
                                <TableRow>
                                    <TableCell rowSpan={3}>{data.acquirer_name}</TableCell>
                                    <TableCell rowSpan={3} align={classAlign}>{merchantName}</TableCell>
                                    <TableCell rowSpan={3} dangerouslySetInnerHTML={{ __html: creditCardPaymentAgencyName }} />
                                    <TableCell>OKICA</TableCell>
                                    <TableCell className={classes.headerStyle1}>{systemFeeOkicaCardPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{brandFeeOkicaCardPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{systemFeeQrPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{brandFeeQrPayment}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{merchantFeeOkicaCardCharge}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{merchantFeeOkicaCardValueExchange}</TableCell>
                                    <TableCell className={classes.headerStyle1} dangerouslySetInnerHTML={{ __html: systemFeeCreditCardPayment}} />
                                    <TableCell className={classes.headerStyle1} dangerouslySetInnerHTML={{ __html: brandFeeCreditCardPayment }} />
                                    <TableCell className={classes.headerStyle2}>{systemFeeBankPayment}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{brandFeeBankPayment}</TableCell>
                                </TableRow>
                            )
                        }
                        else {
                            return (
                                <TableRow>
                                    <TableCell>{data.row_type_name}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{systemFeeOkicaCardPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{brandFeeOkicaCardPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{systemFeeQrPayment}</TableCell>
                                    <TableCell className={classes.headerStyle1}>{brandFeeQrPayment}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{merchantFeeOkicaCardCharge}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{merchantFeeOkicaCardValueExchange}</TableCell>
                                    <TableCell className={classes.headerStyle1} dangerouslySetInnerHTML={{ __html: systemFeeCreditCardPayment }} />
                                    <TableCell className={classes.headerStyle1} dangerouslySetInnerHTML={{ __html: brandFeeCreditCardPayment }} />
                                    <TableCell className={classes.headerStyle2}>{systemFeeBankPayment}</TableCell>
                                    <TableCell className={classes.headerStyle2}>{brandFeeBankPayment}</TableCell>
                                </TableRow>
                            )
                        }
                    },
                    Action: actionProps => {
                        return (
                            <div></div>
                        )
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(FeeList);
